const STORAGE_KEY = 'dizee:digest:lastSeen'
const SESSION_KEY = 'dizee:digest:dismissedThisSession'

/**
 * Get the most recent midnight in Central Time as a UTC timestamp.
 * Uses Intl to handle CDT/CST automatically.
 */
function getLastMidnightCT(): number {
  const now = new Date()
  const ctString = now.toLocaleString('en-US', { timeZone: 'America/Chicago' })
  const ctNow = new Date(ctString)
  ctNow.setHours(0, 0, 0, 0)
  const ctMidnightStr = ctNow.toLocaleString('en-US', { timeZone: 'America/Chicago' })
  const offsetMs = now.getTime() - new Date(ctString).getTime()
  return new Date(ctMidnightStr).getTime() + offsetMs
}

export function isDigestEligible(userId: string): boolean {
  if (sessionStorage.getItem(SESSION_KEY)) return false

  try {
    const raw = localStorage.getItem(`${STORAGE_KEY}:${userId}`)
    if (!raw) return true
    const lastSeen = Number(raw)
    if (!Number.isFinite(lastSeen)) return true
    return lastSeen < getLastMidnightCT()
  } catch {
    return true
  }
}

export function markDigestSeen(userId: string): void {
  try {
    localStorage.setItem(`${STORAGE_KEY}:${userId}`, String(Date.now()))
    sessionStorage.setItem(SESSION_KEY, '1')
  } catch { /* quota errors */ }
}

export function markDigestDismissedForSession(): void {
  try {
    sessionStorage.setItem(SESSION_KEY, '1')
  } catch { /* ignore */ }
}
